up.layer.config.popup.position = 'bottom'

up.layer.config.modal.history = false

up.script.config.scriptElementPolicy = 'block'
up.script.config.callbackPolicy = 'nonce'

up.history.config.updateMetaTags = true

const linkToURL = 'a[href]:not([href="#"])'
up.link.config.followSelectors.push(linkToURL)
up.link.config.instantSelectors.push(linkToURL)
up.link.config.preloadSelectors.push(linkToURL)
up.form.config.submitSelectors.push('form')
up.form.config.noSubmitSelectors.push('#export-form')

up.status.config.currentClasses.push('-active')

up.on('up:layer:opened', function(event) {
  if (event.layer.mode === 'modal') {
    const upModalDismiss = event.layer.element.querySelector('up-modal-dismiss')
    upModalDismiss.innerHTML = ''
    up.element.affix(upModalDismiss, 'span[aria-hidden=true].overlay-dismiss-icon')
  }
})

if (document.body.dataset.env === 'test') {
  // Don't preload in tests.
  up.link.config.preloadDelay = 10 * 1000

  // Disable animation globally in tests so Selenium won't try
  // to click on an element that is being morphed.
  up.motion.config.enabled = false

  // Only allow a single concurrent request in tests to make
  // some tests more deterministic.
  up.network.config.concurrency = 1

  up.log.enable()
}

// Don't cache edit forms
const defaultAutoCache = up.network.config.autoCache
up.network.config.autoCache = function(request) {
  return defaultAutoCache(request) && !request.url.endsWith('/edit')
}
